<template>
  <Integration
    v-bind="{ ...$attrs, reference: { onModel: 'Project', ref: $route.params.id } }"
    v-on="$listeners"
    @installed="installed"
  />
</template>

<script>
import Integration, { meta as globalMeta } from '@/components/Integration/Step'

const meta = { ...globalMeta, order: 1007 }

export { meta }
export default {
  methods: {
    installed() {
      this.$bus.$emit('actions:refetch', 'project')
      this.$store.dispatch('Project/fetch', { id: this.$route.params.id })
    },
  },
  components: {
    Integration,
  },
}
</script>
